import { Link } from "react-router-dom";
import LegalPageLayout from "../../layout/LegalPageLayout";

function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Politika privatnosti">
      <h4>VODITELJ OBRADE:</h4>
      <p>
        Obrt za poduke "LUMEN" (dalje u tekstu: Lumen) vl. Karmen Dasović,
        Rijeka, Fiorella la Guardia 12
      </p>
      <p>
        Kontakt podaci voditelja obrade: telefon:{" "}
        <a href="tel:+38598482065">+385 98 482 065</a>, email:{" "}
        <a href="mailto:k_bljaic@yahoo.com">k_bljaic@yahoo.com</a>
      </p>
      <h4>1. SVRHA I PRAVNI TEMELJI ZA OBRADU OSOBNIH PODATAKA</h4>
      <p>
        Vaši osobni podaci obrađuju se zbog zakonskih obveza ili iako je obrada
        nužna za izvršenje ugovora ili radi poduzimanja pripremnih radnji prije
        sklapanja ugovora ili u svrhe naših legitimnih interesa, osim kada takve
        interese nadjačaju temeljna prava i slobode ispitanika koji zahtijevaju
        zaštitu osobnih podatka. Primjer za zadnje navedeno je obrada u
        marketinške svrhe ili za poboljšanje našeg poslovanja i vašeg
        korisničkog iskustva. Ako se osobni podaci ne mogu obraditi na temelju
        gore navedene pravne osnove, za obradu podataka potreban je vaš
        pristanak. U tom slučaju imate pravo povući privolu u bilo kojem
        trenutku. O povlačenju privole možete nas u svakom trenutku obavijestiti
        putem e-mail adrese: k_bljaic@yahoo.com ili putem adrese: Obrt za poduke
        "LUMEN", Rijeka, Fiorella la Guardia 12. Takvo povlačenje neće utjecati
        na zakonitost obrade na temelju privole prije povlačenja iste. Osobni
        podaci se izravno prikupljaju od vas kada nam ih pružite, primjerice
        ispunjavanjem obrasca ili putem dostupnih javnih informacija.
      </p>
      <h4>2. KATEGORIJE I VRSTE OSOBNIH PODATAKA KOJE OBRAĐUJEMO</h4>
      <p>
        Lumen prikuplja osobne podatke za jedinstvenu identifikaciju korisnika,
        analizu i provedbu usluga instrukcija, marketing i druge potrebne vrste
        tehničke podrške. Na web stranici www.lumenathome.com Lumen prikuplja
        osobne podatke ispitanika kao što su ime, prezime, naziv škole, kontakt
        broj mobitela roditelja, kontakt broj mobitela učenika, e-mail roditelja
        i e-mail učenika te predmete za koje se učenik prijavljuje. Na temelju
        legitimnog interesa i u svrhu marketinga Lumena na popis newslettera
        Lumena mogu se dodati adrese e-pošte učenika i/ili roditelja čiji
        učenici pohađaju ili su pohađali poduke Lumena. U tu svrhu obrađujemo
        e-mail adrese učenika i roditelja (klijenata) koje mogu sadržavati
        osobne podatke kao što su imena i podaci o radnom mjestu. Svi klijenti
        čija se adresa e-pošte nalazi na popisu newslettera mogu u bilo kojem
        trenutku zatražiti prestanak primanja newslettera, kontaktiranjem
        izravno Lumena ili korištenjem poveznice za odjavu u bilo kojoj
        promotivnoj poruci Lumena. Lumen prikuplja i obrađuje osobne podatke od
        svojih zaposlenika i izvođača u svrhu izvršenja sklopljenih ugovora o
        radu i ugovora o djelu. Lumen prikuplja i obrađuje neke ili sve sljedeće
        podatke od zaposlenika i izvođača: ime, prezime i prethodno prezime
        zaposlenika ili izvođača (ako je primjenjivo); spol; ime oca;
        državljanstvo; nacionalnost, stalna adresa; privremena adresa
        (privremeno boravište, ako je primjenjivo); datum i mjesto rođenja;
        osobni identifikacijski broj; jedinstveni broj državljana; Broj osobne
        iskaznice/putovnice, fotografija, stručna i akademska sprema; broj
        socijalnog osiguranja; broj zdravstvenog osiguranja, radno iskustvo;
        popis dosadašnjih poslodavaca; trajanje prethodnih radnih odnosa i vrstu
        posla; detalji bankovnog računa; ime djeteta, odnosno djece, datum
        rođenja djeteta, odnosno djece. Lumen od posjetitelja web-stranice
        prikuplja identifikacijske i statističke podatke o posjetima i
        korištenju pojedinih stranica unutar www.lumenathome.com radi analize i
        poboljšanja korisničkog iskustva.
      </p>
      <h4>3. OSNOVE ZA OBRADU</h4>
      <p>
        Lumen može obrađivati vaše osobne podatke samo i u mjeri u kojoj je to
        opravdano jednim od pravnih temelja:
      </p>
      <ul>
        <li>ispitanik je dao privolu za obradu svojih osobnih podataka</li>
        <li>
          obrada je nužna za izvršavanje ugovora u kojem je ispitanik stranka
          ili kako bi se poduzele radnje na zahtjev ispitanika prije sklapanja
          ugovora
        </li>
        <li>obrada je nužna radi poštivanja pravnih obveza voditelja obrade</li>
        <li>
          obrada je nužna radi zaštite životno važnih interesa ispitanika ili
          druge fizičke osobe
        </li>
        <li>
          obrada je nužna iza izvršavanje zadaće od javnog interesa ili pri
          vršenju službene ovlasti voditelja obrade
        </li>
        <li>
          obrada je nužna za potrebe legitimnih interesa voditelja obrade ili
          treće strane, osim kada su od tih interesa jači interesi ili temeljna
          prava i slobode ispitanika koji zahtijevaju zaštitu osobnih podataka,
          posebno kada je ispitanik dijete
        </li>
      </ul>
      <h4>4. KORIŠTENJE KOLAČIĆA (COOKIES)</h4>
      <p>
        Na internetskim stranicama www.lumenathome.com koriste se tzv. kolačići
        (cookies) – tekstualne datoteke koje na računalo korisnika smješta
        internetski poslužitelj (server), putem kojeg davatelj usluge pristupa
        Internetu (ISP) prikazuje web stranicu. Kolačići nastaju kada preglednik
        na uređaju korisnika učita posjećeno mrežno odredište, koje potom šalje
        podatke pregledniku te izrađuje tekstualnu datoteku (kolačić).
        Preglednik dohvaća i šalje kolačić na poslužitelj internetske stranice
        prilikom povratka korisnika na njega. Mogu biti privremeni ili trajni.
        Kolačići omogućuju pristupanje relevantnim informacijama na web
        stranici. Na web stranici Lumena koriste se tehnički kolačići (obavezni
        kolačići, ne mogu se isključiti) koji su nužni za funkcioniranje
        Internet mjesta. Više informacija možete pronaći na sljedećoj poveznici:{" "}
        <Link to="/cookie-policy">www.lumenathome.com/cookie-policy</Link>
      </p>
      <h4>5. VAŠA PRAVA U VEZI OBRADE OSOBNIH PODATAKA</h4>
      <p>
        Za ostvarivanje svojih prava možete nam se obratiti pisanim putem Obrt
        za poduke "LUMEN", Rijeka, Fiorella la Guardia 12 ili putem elektroničke
        pošte k_bljaic@yahoo.com. Vaša prava su:
      </p>
      <ul>
        <li>
          Pravo na pristup osobnim informacijama – Imate pravo dobiti potvrdu
          obrađuju li se vaši osobni podaci, te ako se obrađuju, pristup tim
          podacima i dodatnim informacijama. Ovo pravo uključuje sljedeće
          informacije: svrhe obrade, kategorije osobnih podataka koji se
          obrađuju, primatelje ili kategorije primatelja kojima su osobni podaci
          otkriveni ili će biti otkriveni, posebno primatelje u trećim zemljama
          ili međunarodnim organizacijama. Međutim, prava i interesi drugih
          pojedinaca mogu u nekim slučajevima ograničiti vaše pravo pristupa.
        </li>
        <li>
          Pravo na ispravak osobnih podataka – Imate pravo zahtijevati ispravak
          netočnih osobnih podataka koji se na odnose na vas. Također, imate
          pravo na dopunu nepotpunih osobnih podataka, između ostalog i davanjem
          dodatne izjave.
        </li>
        <li>
          Pravo na brisanje – Imate pravo zatražiti brisanje svojih osobnih
          podataka kada postoje određeni razlozi.
        </li>
        <li>
          Pravo na ograničavanje obrade osobnih podataka – Imate pravo zatražiti
          ograničenje obrade svojih osobnih podataka kada postoje određeni
          razlozi. Kada je obrada ograničena, takvi osobni podaci smiju se
          obrađivati samo uz vašu privolu ili za uspostavljanje, ostvarivanje
          ili obranu pravnih zahtjeva ili za zaštitu prava druge fizičke ili
          pravne osobe ili zbog važnog javnog interesa Europske Unije ili države
          članice.
        </li>
        <li>
          Pravo na prigovor – Pod određenim uvjetima, imate pravo uložiti
          prigovor na obradu vaših osobnih podataka. Imate pravo zahtijevati od
          nas da zaustavimo obradu vaših osobnih podataka.
        </li>
        <li>
          Pravo na prenosivost osobnih podataka – Pod određenim uvjetima, imate
          pravo dobiti svoje osobne podatke koje ste nam dali u strukturiranom,
          uobičajeno korištenom i strojno čitljivom formatu, te da te podatke
          prenesu drugom voditelju obrade bez ometanja od strane prvotnog
          voditelja obrade.
        </li>
      </ul>
      <p>
        U slučaju da mislite da su vam povrijeđena neka od navedenih prava,
        možete podnijeti pritužbu Agenciji za zaštitu osobnih podataka, Selska
        cesta 136, 10000 Zagreb.
      </p>
      <h4>6. DAVANJE NA KORIŠTENJE OSOBNIH PODATAKA</h4>
      <p>
        Vaše osobne podatke možemo proslijediti davateljima
        informatičko-komunikacijskih rješenja i usluga na korištenje. To su naši
        izvršitelji obrade s kojima smo sklopili ugovore u kojima smo propisali
        postupanje s osobnim podacima. Izvršitelji obrade smiju obrađivati vaše
        osobne podatke samo po našim uputama i isključivo u unaprijed navedene
        svrhe. Također, obvezujemo ih da vaše osobne podatke smatraju poslovnom
        tajnom. Pod određenim uvjetima, imamo pravnu obvezu za prosljeđivanjem
        vaših osobnih podataka. Obradom osobnih podataka može biti obuhvaćen i
        njihov međunarodni prijenos izvan Europskog gospodarskog prostora kada
        je to potrebno radi izvršavanja ugovora između ispitanika i Lumena ili
        za ispunjavanje zakonskih obveza. Prijenos osobnih podataka dopušten je
        samo u zemlje koje pružaju adekvatnu razinu zaštite osobnih podataka.
      </p>
      <h4>7. SIGURNOST I POVJERLJIVOST OSOBNIH PODATAKA</h4>
      <p>
        Lumen obrađuje osobne podatke na način koji osigurava sigurnost i
        povjerljivost. Poduzimamo mjere zaštite na organizacijskoj i tehničkoj
        razini kako bismo spriječili slučajno ili nezakonito uništenje, gubitak,
        otkrivanje, pristup, izmjene ili neovlaštenu uporabu podataka od bilo
        koje organizacijske ili pojedinca. Redovito testiramo tehničke i
        organizacijske mjere kako bi smo procijenili njihovu adekvatnost za
        osiguravanje sigurnosti obrade. Svi zaposlenici i suradnici Lumena
        obvezuju se na čuvanje osobnih podataka potpisivanjem izjave o
        povjerljivosti.
      </p>
      <h4>8. VREMENSKI PERIOD ČUVANJA OSOBNIH PODATAKA</h4>
      <p>
        Vaše osobne podatke obrađujemo dok se ne ispuni svrha zbog koje su
        prikupljeni. Nakon što svrha bude ispunjena, prestajemo koristiti Vaše
        osobne podatke, ali ih zadržavamo u našem sustavu onoliko dugo koliko to
        zahtijevaju zakonski propisi o čuvanju arhivskog gradiva. Ako ste dali
        privolu za obradu osobnih podataka, oni će se obrađivati do povlačenja
        privole ili ispunjenja svrhe obrade. Nadalje, Vaši osobni podaci više se
        neće obrađivati ako podnesete opravdani prigovor protiv obrade koja se
        temelji na legitimnom interesu.
      </p>
      <h4>9. KONTAKT INFORMACIJE</h4>
      <p>
        Ako imate pitanja u vezi obrade Vaših osobnih podataka, možete nam se
        obratiti na email adresu{" "}
        <a href="mailto:k_bljaic@yahoo.com">k_bljaic@yahoo.com</a> ili
        telefonski na <a href="tel:+38598482065">+385 98 482 065</a>.
      </p>
      <h4>10. PROMJENE POLITIKE PRIVATNOSTI</h4>
      <p>
        Politiku privatnosti ažuriramo te pridržavamo pravo njene promjene po
        potrebi. Sva ažuriranja ćemo pravovremeno objavljivati na ovoj web
        stranici.
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyPolicyPage;
